import { render, staticRenderFns } from "./DmqCheckoutAddresses.vue?vue&type=template&id=6b95f6c8&"
import script from "./DmqCheckoutAddresses.vue?vue&type=script&lang=ts&"
export * from "./DmqCheckoutAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports